import { countrySelector } from './country-selector.js';
import { magnificPopup } from './magnific-popup.js';
import { simpleFiltering } from './simple-filtering.js';
import { ourPeople } from './our-people.js';

export const initAssets = () => {
    countrySelector.init();
    magnificPopup.init();
    simpleFiltering.init();
    ourPeople.init();
}